// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  extraPay: (t, data?, options?) => t('enum.payment-status.extra-pay.name', data, options),
  extraPenalty: (t, data?, options?) => t('enum.payment-status.extra-penalty.name', data, options),
  none: (t, data?, options?) => t('enum.payment-status.none.name', data, options),
  pay: (t, data?, options?) => t('enum.payment-status.pay.name', data, options),
  penalty: (t, data?, options?) => t('enum.payment-status.penalty.name', data, options),
  /* eslint-enable max-len */
};
